import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'

const SettingsSelector = ({ selected, onSelect }) => {
    return (
        <RadioGroup defaultValue={selected} onValueChange={onSelect}>
            <div className="tw:flex tw:items-start tw:gap-4">
                <RadioGroupItem value="default" id="default" />
                <div className="tw:flex tw:flex-col tw:gap-1">
                    <Label htmlFor="default" className="tw:cursor-pointer">
                        Use default parameters
                    </Label>
                    <Label htmlFor="default" className="tw:text-sm tw:text-gray-200 tw:max-w-sm tw:cursor-pointer">
                        Default parameters are optimal for most cases and are based on our statistics.
                    </Label>
                </div>
            </div>
            <div className="tw:flex tw:items-start tw:gap-4 tw:mt-4">
                <RadioGroupItem value="manual" id="manual" />
                <div className="tw:flex tw:flex-col tw:gap-1">
                    <Label htmlFor="manual" className="tw:cursor-pointer">
                        Manual parameters
                    </Label>
                    <Label className="tw:text-sm tw:text-gray-200 tw:max-w-sm tw:cursor-pointer" htmlFor="manual">
                        Fine-tune all the details for every audience.
                    </Label>
                </div>
            </div>
        </RadioGroup>
    )
}

export default SettingsSelector
